import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import classnames from "classnames";
import {
  registrationFieldUpdate,
  postEventShiftDetailsFieldValidate
} from "redux/ducks/Registration";
import {
  optionsForEnum,
  otherLast,
  sportsFilter
} from "helpers/enums";

const PostEventShiftDetails = ({
  history,
  updateField,
  user,
  validateField,
  validation,
  enums
}) => {

  const onFieldValidate = field => {
    validateField(field);
  };

  const onPrevious = e => {
    e.preventDefault();
    history.push("/sign-up/post-event/profile")
  };

  const onNext = e => {
    e.preventDefault();
    history.push("/sign-up/post-event/password")
  };

  const onFieldChange = (field, triggerValidate) => {
    return (ev: SyntheticInputEvent<HTMLInputElement>) => {
      updateField(field, ev.currentTarget.value);
      if (triggerValidate) {
        onFieldValidate(field);
      }
    };
  };

  return (
    <div className="postEvent">
      <h2>Now, let's get some shift details:</h2>
      <form id="accountForm" noValidate>
        <div className="form-group">
          <label className="required" htmlFor="eventName">Event Name</label>
          <input
            type="eventName"
            placeholder="Event Name"
            value={user.eventName}
            className={classnames("form-control", {
              "is-invalid": validation.errors.eventName
            })}
            name="eventName"
            onChange={onFieldChange("eventName")}
            onBlur={onFieldValidate.bind(this, "eventName")}
          />
          <div className="invalid-feedback">{validation.errors.eventName}</div>
        </div>
        {user.postEventMasterType === "sports" &&
          <div className="form-group">
            <label className="required" htmlFor="eventTypeId">Type of Event</label>
            <select
              placeholder="Event Type"
              className={classnames("form-control custom-select", {
                "is-invalid": validation.errors.eventTypeId
              })}
              name="eventTypeId"
              onChange={onFieldChange("eventTypeId")}
              onBlur={onFieldValidate.bind(this, "eventTypeId")}
            >
              {optionsForEnum(otherLast(enums.eventTypes))}
            </select>
            <div className="invalid-feedback">{validation.errors.eventTypeId}</div>
          </div>
        }
        {user.postEventMasterType === "sports" &&
          <div className="form-group">
            <label className="required" htmlFor="sportId">Sport</label>
            <select
              value={user.sportId}
              className={classnames("form-control custom-select", {
                "is-invalid": validation.errors.sportId
              })}
              name="sportId"
              onChange={onFieldChange('sportId')}
              onBlur={onFieldValidate.bind(this, "sportId")} >
              {optionsForEnum(sportsFilter(enums.sports))}
            </select>
            <div className="invalid-feedback">{validation.errors.sportId}</div>
          </div>
        }
        {user.postEventMasterType === "sports" &&
          <div className="form-group">
            <label className="required" htmlFor="ageBracketIds">Age</label>
            <select
              value={user.ageBracketIds}
              className={classnames("form-control custom-select", {
                "is-invalid": validation.errors.ageBracketIds
              })}
              name="ageBracketIds"
              onChange={onFieldChange('ageBracketIds')}
              onBlur={onFieldValidate.bind(this, "ageBracketId")} >
              {optionsForEnum(enums.ageBrackets)}
            </select>
            <div className="invalid-feedback">{validation.errors.ageBracketIds}</div>
          </div>
        }
        {user.postEventMasterType === "sports" &&
          <div className="form-group">
            <label className="required" htmlFor="genderId">Gender</label>
            <select
              type="text"
              value={user.genderId}
              placeholder="GenderId"
              className={classnames("form-control custom-select", {
                "is-invalid": validation.errors.genderId
              })}
              name="genderId"
              onChange={onFieldChange("genderId")}
              onBlur={onFieldValidate.bind(this, "genderId")} >
              {optionsForEnum(enums.genders)}
            </select>
            <div className="invalid-feedback">{validation.errors.genderId}</div>
          </div>
        }
        {user.postEventMasterType !== "sports" &&
          <div className="form-group">
            <label className="required" htmlFor="settingTypeId">Setting</label>
            <select
              type="text"
              value={user.settingTypeId}
              placeholder="settingTypeId"
              className={classnames("form-control custom-select", {
                "is-invalid": validation.errors.settingTypeId
              })}
              name="settingTypeId"
              onChange={onFieldChange("settingTypeId")}
              onBlur={onFieldValidate.bind(this, "settingTypeId")} >
              {optionsForEnum(enums.settingTypes)}
            </select>
            <div className="invalid-feedback">{validation.errors.settingTypeId}</div>
          </div>
        }
        <div className="form-group">
          <label className="required" htmlFor="eventParticipantNumbersId">Estimated Number of Participants</label>
          <select
            type="text"
            placeholder="Estimated Number of Participants"
            className={classnames("form-control custom-select", {
              "is-invalid": validation.errors.eventParticipantNumbersId,
            })}
            name="eventParticipantNumbersId"
            onChange={onFieldChange("eventParticipantNumbersId", true)}
            onBlur={onFieldValidate.bind(this, "eventParticipantNumbersId")} >
            {optionsForEnum(enums.eventParticipantNumbers)}
          </select>
          <div className="invalid-feedback">{validation.errors.eventParticipantNumbersId}</div>
        </div>
        <div className="actions">
          <button
            type="submit"
            className="btn btn-primary bold-button"
            onClick={onPrevious}
          >
            Previous
          </button>
          <button
            type="submit"
            className="btn btn-danger bold-button"
            disabled={!validation.valid}
            onClick={onNext}
          >
            Next
          </button>
        </div>
      </form>
    </div >
  );
};

function mapStateToProps(state) {
  const key = state.registration.user.postEventMasterType === "sports"
    ? "postSportEventShiftDetailsValidation"
    : "postCovidEventShiftDetailsValidation";
  return {
    user: state.registration.user,
    validation: state.registration[key],
    enums: state.enums,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateField: (field, value) =>
      dispatch(registrationFieldUpdate(field, value)),
    validateField: field => dispatch(postEventShiftDetailsFieldValidate(field))
  };
}

export { PostEventShiftDetails };

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PostEventShiftDetails))